/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class ApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Issue a challenge that will authorize the user through covisint.
     * @param redirectUrl (optional) 
     */
    auth_ChallengeCovisint(redirectUrl: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/auth/covisint?";
        if (redirectUrl === null)
            throw new Error("The parameter 'redirectUrl' cannot be null.");
        else if (redirectUrl !== undefined)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuth_ChallengeCovisint(_response);
        });
    }

    protected processAuth_ChallengeCovisint(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 302) {
            return response.text().then((_responseText) => {
                return throwException("Redirect", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Issue a challenge that will authorize the user through Azure.
     * @param redirectUrl (optional) 
     */
    auth_ChallengeAzure(redirectUrl: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/auth/azure?";
        if (redirectUrl === null)
            throw new Error("The parameter 'redirectUrl' cannot be null.");
        else if (redirectUrl !== undefined)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuth_ChallengeAzure(_response);
        });
    }

    protected processAuth_ChallengeAzure(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 302) {
            return response.text().then((_responseText) => {
                return throwException("Redirect", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Log a user out of whatever authentication they are logged in with, then redirect them to the login form.
     * @return Success
     */
    auth_SignOut(): Promise<void> {
        let url_ = this.baseUrl + "/auth/signout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuth_SignOut(_response);
        });
    }

    protected processAuth_SignOut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    index(): Promise<string> {
        let url_ = this.baseUrl + "/AzureAdAuth/Index";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return Success
     */
    signin(): Promise<void> {
        let url_ = this.baseUrl + "/AzureAdAuth/SignIn/signin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignin(_response);
        });
    }

    protected processSignin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    signout(): Promise<void> {
        let url_ = this.baseUrl + "/AzureAdAuth/SignOut/signout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignout(_response);
        });
    }

    protected processSignout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    signedout(): Promise<void> {
        let url_ = this.baseUrl + "/AzureAdAuth/SignedOut/signedout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignedout(_response);
        });
    }

    protected processSignedout(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    dashboard_Dashboard(supplierId: string): Promise<DashboardInfo> {
        let url_ = this.baseUrl + "/v1/Dashboard/{supplierId}";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard_Dashboard(_response);
        });
    }

    protected processDashboard_Dashboard(response: Response): Promise<DashboardInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DashboardInfo.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardInfo>(<any>null);
    }

    /**
     * @return Success
     */
    dashboard_Tasks(supplierId: string): Promise<DashboardTask[]> {
        let url_ = this.baseUrl + "/v1/Dashboard/{supplierId}/Tasks";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDashboard_Tasks(_response);
        });
    }

    protected processDashboard_Tasks(response: Response): Promise<DashboardTask[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(DashboardTask.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardTask[]>(<any>null);
    }

    /**
     * @return Success
     */
    azureaduser(): Promise<string> {
        let url_ = this.baseUrl + "/Home/AzureAdUser/azureaduser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAzureaduser(_response);
        });
    }

    protected processAzureaduser(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    //supplyAction api block start
    supplierRecovery_GetDetails(body: SupplierRecoveryFilterset | undefined): Promise<SupplierRecoveryResponse> {


        let url_ = this.baseUrl + "/v1/SupplierActionRegisters/query";
        url_ = url_.replace(/[?&]$/, "");


        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSupplierRecovery_GetDetails(_response);
        });
    }

    protected processSupplierRecovery_GetDetails(response: Response): Promise<SupplierRecoveryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SupplierRecoveryResponse.fromJS(resultData200);


                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierRecoveryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    supplierRecovery_GetFilterOptions(body: SupplierRecoveryFilterset | undefined): Promise<SupplierRecoveryFilterset> {
        let url_ = this.baseUrl + "/v1/SupplierActionRegisters/filters";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSupplierRecovery_GetFilterOptions(_response);
        });
    }

    protected processSupplierRecovery_GetFilterOptions(response: Response): Promise<SupplierRecoveryFilterset> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SupplierRecoveryFilterset.fromJS(resultData200);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierRecoveryFilterset>(<any>null);
    }
    /**
     * @param body (optional)
     * @return Success
     */




    supplierRecovery_UpdatePartDetails(body: supplierActionRegister | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/SupplierActionRegisters/update";
        url_ = url_.replace(/[?&]$/, "");
        const bodyData = {
            "supplierActionRegister": [
                body
            ]
        }
        const content_ = JSON.stringify(bodyData);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processsupplierRecovery_UpdatePartDetails(_response);
        });
    }

    protected processsupplierRecovery_UpdatePartDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
    //supplyAction api block end
    partDetail_GetPartDetails(body: PartDetailFilterset | undefined): Promise<PartDetailResponse> {
        let url_ = this.baseUrl + "/v1/PartDetail/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPartDetail_GetPartDetails(_response);
        });
    }

    protected processPartDetail_GetPartDetails(response: Response): Promise<PartDetailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PartDetailResponse.fromJS(resultData200);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartDetailResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partDetail_GetFilterOptions(body: PartDetailFilterset | undefined): Promise<PartDetailFilterset> {
        let url_ = this.baseUrl + "/v1/PartDetail/filters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPartDetail_GetFilterOptions(_response);
        });
    }

    protected processPartDetail_GetFilterOptions(response: Response): Promise<PartDetailFilterset> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PartDetailFilterset.fromJS(resultData200);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartDetailFilterset>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partDetail_UpdatePartDetails(supplierId: string, partDetailId: string, body: PartDetail | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/PartDetail/{supplierId}/parts/{partDetailId}";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        if (partDetailId === undefined || partDetailId === null)
            throw new Error("The parameter 'partDetailId' must be defined.");
        url_ = url_.replace("{partDetailId}", encodeURIComponent("" + partDetailId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPartDetail_UpdatePartDetails(_response);
        });
    }

    protected processPartDetail_UpdatePartDetails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    partDetail_DownloadCSV(body: PartDetailFilterset | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/v1/PartDetail/download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPartDetail_DownloadCSV(_response);
        });
    }

    protected processPartDetail_DownloadCSV(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    partDetail_UploadCSV(baseSupplierId: string, file: FileParameter | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/PartDetail/upload/{baseSupplierId}";
        if (baseSupplierId === undefined || baseSupplierId === null)
            throw new Error("The parameter 'baseSupplierId' must be defined.");
        url_ = url_.replace("{baseSupplierId}", encodeURIComponent("" + baseSupplierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPartDetail_UploadCSV(_response);
        });
    }

    protected processPartDetail_UploadCSV(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    partDetail_GetKeyConstraints(): Promise<string[]> {
        let url_ = this.baseUrl + "/v1/PartDetail/key-constraints";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPartDetail_GetKeyConstraints(_response);
        });
    }

    protected processPartDetail_GetKeyConstraints(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    partDetail_GetMitigationMeasures(): Promise<string[]> {
        let url_ = this.baseUrl + "/v1/PartDetail/mitigation-measures";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPartDetail_GetMitigationMeasures(_response);
        });
    }

    protected processPartDetail_GetMitigationMeasures(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    ping(): Promise<void> {
        let url_ = this.baseUrl + "/v1/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPing(_response);
        });
    }

    protected processPing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Add notes to a particular demand item.
     * @param body (optional) 
     * @return Success
     */
    supplier_AddNotes(body: AddNotesRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/Supplier/notes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSupplier_AddNotes(_response);
        });
    }

    protected processSupplier_AddNotes(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Retrieve supplier information from downstream services.
     * @param body (optional) 
     * @return Success
     */
    supplier_GetSupplierData(body: SupplierFilterset | undefined): Promise<SupplierInfoResponse> {
        let url_ = this.baseUrl + "/v1/Supplier/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSupplier_GetSupplierData(_response);
        });
    }

    protected processSupplier_GetSupplierData(response: Response): Promise<SupplierInfoResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SupplierInfoResponse.fromJS(resultData200);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierInfoResponse>(<any>null);
    }

    /**
     * Upload a CSV and parse it into downstream stores.
    Will accept a CSV with columns matching SupplierCapacityTool.Core.Models.Domain.SupplierInfo.
     * @param supplierId The ID of the supplier we are uploading data for.
     * @param file (optional) 
     * @return Success
     */
    supplier_UploadCSV(supplierId: string, file: FileParameter | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/Supplier/{supplierId}";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSupplier_UploadCSV(_response);
        });
    }

    protected processSupplier_UploadCSV(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ValidationProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 415) {
            return response.text().then((_responseText) => {
                let result415: any = null;
                let resultData415 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result415 = ProblemDetails.fromJS(resultData415);
                return throwException("Client Error", status, _responseText, _headers, result415);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Download a CSV that matches the given filterset
     * @param body (optional) 
     * @return Success
     */
    supplier_DownloadCSV(supplierId: string, body: SupplierFilterset | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/v1/Supplier/{supplierId}/download";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSupplier_DownloadCSV(_response);
        });
    }

    protected processSupplier_DownloadCSV(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }

    /**
     * Get available filterset options.
     * @param body (optional) 
     * @return Success
     */
    supplier_GetFilters(body: SupplierFilterset | undefined): Promise<SupplierFilterset> {
        let url_ = this.baseUrl + "/v1/Supplier/filters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSupplier_GetFilters(_response);
        });
    }

    protected processSupplier_GetFilters(response: Response): Promise<SupplierFilterset> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SupplierFilterset.fromJS(resultData200);
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierFilterset>(<any>null);
    }

    /**
     * @return Success
     */
    suppliers(partialSupplierIdOrName: string): Promise<SupplierIdName[]> {
        let url_ = this.baseUrl + "/v1/Supplier/suppliers/{partialSupplierIdOrName}";
        if (partialSupplierIdOrName === undefined || partialSupplierIdOrName === null)
            throw new Error("The parameter 'partialSupplierIdOrName' must be defined.");
        url_ = url_.replace("{partialSupplierIdOrName}", encodeURIComponent("" + partialSupplierIdOrName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuppliers(_response);
        });
    }

    protected processSuppliers(response: Response): Promise<SupplierIdName[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(SupplierIdName.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierIdName[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    supplier_UpdateCapacityInfo(supplierId: string, partNumber: string, demandId: string, body: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/Supplier/{supplierId}/parts/{partNumber}/demand/{demandId}/capacity";
        if (supplierId === undefined || supplierId === null)
            throw new Error("The parameter 'supplierId' must be defined.");
        url_ = url_.replace("{supplierId}", encodeURIComponent("" + supplierId));
        if (partNumber === undefined || partNumber === null)
            throw new Error("The parameter 'partNumber' must be defined.");
        url_ = url_.replace("{partNumber}", encodeURIComponent("" + partNumber));
        if (demandId === undefined || demandId === null)
            throw new Error("The parameter 'demandId' must be defined.");
        url_ = url_.replace("{demandId}", encodeURIComponent("" + demandId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSupplier_UpdateCapacityInfo(_response);
        });
    }

    protected processSupplier_UpdateCapacityInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400: any = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                let result401: any = null;
                let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result401 = ProblemDetails.fromJS(resultData401);
                return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
                let result403: any = null;
                let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result403 = ProblemDetails.fromJS(resultData403);
                return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

  

    /**
     * Retrieve which suppliers, if any, the user has access to.
     * @return Success
     */
    users_GetUserInfo(): Promise<UserInfo> {
        let url_ = this.baseUrl + "/users/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUsers_GetUserInfo(_response);
        });
    }

    protected processUsers_GetUserInfo(response: Response): Promise<UserInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserInfo.fromJS(resultData200);
                return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfo>(<any>null);
    }
}

export class AddNotesRequest implements IAddNotesRequest {
    baseSupplierId?: string | undefined;
    partNumber?: string | undefined;
    demandId?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IAddNotesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSupplierId = _data["baseSupplierId"];
            this.partNumber = _data["partNumber"];
            this.demandId = _data["demandId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): AddNotesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddNotesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSupplierId"] = this.baseSupplierId;
        data["partNumber"] = this.partNumber;
        data["demandId"] = this.demandId;
        data["notes"] = this.notes;
        return data;
    }

    clone(): AddNotesRequest {
        const json = this.toJSON();
        let result = new AddNotesRequest();
        result.init(json);
        return result;
    }
}

export interface IAddNotesRequest {
    baseSupplierId?: string | undefined;
    partNumber?: string | undefined;
    demandId?: string | undefined;
    notes?: string | undefined;
}

export class DashboardInfo implements IDashboardInfo {
    numberOfTotalItems?: number;
    numberOfItemsNeedingCapacityLoaded?: number;
    numberOfItemsExceedingThreshold?: number;
    numberOfStaleItems?: number;
    numberOfDemandLinesWithoutCapacityBaselineLoaded?: number;

    constructor(data?: IDashboardInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfTotalItems = _data["numberOfTotalItems"];
            this.numberOfItemsNeedingCapacityLoaded = _data["numberOfItemsNeedingCapacityLoaded"];
            this.numberOfItemsExceedingThreshold = _data["numberOfItemsExceedingThreshold"];
            this.numberOfStaleItems = _data["numberOfStaleItems"];
            this.numberOfDemandLinesWithoutCapacityBaselineLoaded = _data["numberOfDemandLinesWithoutCapacityBaselineLoaded"];
        }
    }

    static fromJS(data: any): DashboardInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfTotalItems"] = this.numberOfTotalItems;
        data["numberOfItemsNeedingCapacityLoaded"] = this.numberOfItemsNeedingCapacityLoaded;
        data["numberOfItemsExceedingThreshold"] = this.numberOfItemsExceedingThreshold;
        data["numberOfStaleItems"] = this.numberOfStaleItems;
        data["numberOfDemandLinesWithoutCapacityBaselineLoaded"] = this.numberOfDemandLinesWithoutCapacityBaselineLoaded;
        return data;
    }

    clone(): DashboardInfo {
        const json = this.toJSON();
        let result = new DashboardInfo();
        result.init(json);
        return result;
    }
}

export interface IDashboardInfo {
    numberOfTotalItems?: number;
    numberOfItemsNeedingCapacityLoaded?: number;
    numberOfItemsExceedingThreshold?: number;
    numberOfStaleItems?: number;
    numberOfDemandLinesWithoutCapacityBaselineLoaded?: number;
}

export class DashboardTask implements IDashboardTask {
    baseSupplierId?: string | undefined;
    partNumber?: string | undefined;
    taskType?: TaskType;

    constructor(data?: IDashboardTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSupplierId = _data["baseSupplierId"];
            this.partNumber = _data["partNumber"];
            this.taskType = _data["taskType"];
        }
    }

    static fromJS(data: any): DashboardTask {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSupplierId"] = this.baseSupplierId;
        data["partNumber"] = this.partNumber;
        data["taskType"] = this.taskType;
        return data;
    }

    clone(): DashboardTask {
        const json = this.toJSON();
        let result = new DashboardTask();
        result.init(json);
        return result;
    }
}

export interface IDashboardTask {
    baseSupplierId?: string | undefined;
    partNumber?: string | undefined;
    taskType?: TaskType;
}

export enum ListSortDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export enum PartCriticalityEnum {
    Low = "Low",
    Medium = "Medium",
    High = "High",
    Extreme = "Extreme",
}

export class PartDetail implements IPartDetail {
    supplierId?: string | undefined;
    baseSupplierId?: string | undefined;
    supplierName?: string | undefined;
    partNumber?: string | undefined;
    partDescription?: string | undefined;
    contractualCapacity?: number | undefined;
    annualCapacity?: number | undefined;
    monthlyCapacity?: number[] | undefined;
    keyConstraints?: string[] | undefined;
    mitigationMeasures?: string[] | undefined;
    programmedBaseline?: boolean;
    lastUpdatedBy?: string | undefined;
    lastUpdatedOn?: Date | undefined;
    notes?: string | undefined;

    constructor(data?: IPartDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierId = _data["supplierId"];
            this.baseSupplierId = _data["baseSupplierId"];
            this.supplierName = _data["supplierName"];
            this.partNumber = _data["partNumber"];
            this.partDescription = _data["partDescription"];
            this.contractualCapacity = _data["contractualCapacity"];
            this.annualCapacity = _data["annualCapacity"];
            if (Array.isArray(_data["monthlyCapacity"])) {
                this.monthlyCapacity = [] as any;
                for (let item of _data["monthlyCapacity"])
                    this.monthlyCapacity!.push(item);
            }
            if (Array.isArray(_data["keyConstraints"])) {
                this.keyConstraints = [] as any;
                for (let item of _data["keyConstraints"])
                    this.keyConstraints!.push(item);
            }
            if (Array.isArray(_data["mitigationMeasures"])) {
                this.mitigationMeasures = [] as any;
                for (let item of _data["mitigationMeasures"])
                    this.mitigationMeasures!.push(item);
            }
            this.programmedBaseline = _data["programmedBaseline"];
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdatedOn = _data["lastUpdatedOn"] ? new Date(_data["lastUpdatedOn"].toString()) : <any>undefined;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): PartDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PartDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId;
        data["baseSupplierId"] = this.baseSupplierId;
        data["supplierName"] = this.supplierName;
        data["partNumber"] = this.partNumber;
        data["partDescription"] = this.partDescription;
        data["contractualCapacity"] = this.contractualCapacity;
        data["annualCapacity"] = this.annualCapacity;
        if (Array.isArray(this.monthlyCapacity)) {
            data["monthlyCapacity"] = [];
            for (let item of this.monthlyCapacity)
                data["monthlyCapacity"].push(item);
        }
        if (Array.isArray(this.keyConstraints)) {
            data["keyConstraints"] = [];
            for (let item of this.keyConstraints)
                data["keyConstraints"].push(item);
        }
        if (Array.isArray(this.mitigationMeasures)) {
            data["mitigationMeasures"] = [];
            for (let item of this.mitigationMeasures)
                data["mitigationMeasures"].push(item);
        }
        data["programmedBaseline"] = this.programmedBaseline;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdatedOn"] = this.lastUpdatedOn ? this.lastUpdatedOn.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        return data;
    }

    clone(): PartDetail {
        const json = this.toJSON();
        let result = new PartDetail();
        result.init(json);
        return result;
    }
}

export interface IPartDetail {
    supplierId?: string | undefined;
    baseSupplierId?: string | undefined;
    supplierName?: string | undefined;
    partNumber?: string | undefined;
    partDescription?: string | undefined;
    contractualCapacity?: number | undefined;
    annualCapacity?: number | undefined;
    monthlyCapacity?: number[] | undefined;
    keyConstraints?: string[] | undefined;
    mitigationMeasures?: string[] | undefined;
    programmedBaseline?: boolean;
    lastUpdatedBy?: string | undefined;
    lastUpdatedOn?: Date | undefined;
    notes?: string | undefined;
}

export class PartDetailFilterset implements IPartDetailFilterset {
    sortDirection?: ListSortDirection;
    sortBy?: PartDetailSortOption;
    pageSize?: number;
    page?: number;
    supplierIds?: string[] | undefined;
    partNumber?: string[] | undefined;
    mitigationMeasures?: string[] | undefined;
    keyConstraints?: string[] | undefined;
    minAnnualCapacity?: number | undefined;
    maxAnnualCapacity?: number | undefined;
    hasMonthlyVariability?: boolean | undefined;
    hasProgrammedBaseline?: boolean | undefined;
    hasAnnualCapacity?: boolean | undefined;

    constructor(data?: IPartDetailFilterset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortDirection = _data["sortDirection"];
            this.sortBy = _data["sortBy"];
            this.pageSize = _data["pageSize"];
            this.page = _data["page"];
            if (Array.isArray(_data["supplierIds"])) {
                this.supplierIds = [] as any;
                for (let item of _data["supplierIds"])
                    this.supplierIds!.push(item);
            }
            if (Array.isArray(_data["partNumber"])) {
                this.partNumber = [] as any;
                for (let item of _data["partNumber"])
                    this.partNumber!.push(item);
            }
            if (Array.isArray(_data["mitigationMeasures"])) {
                this.mitigationMeasures = [] as any;
                for (let item of _data["mitigationMeasures"])
                    this.mitigationMeasures!.push(item);
            }
            if (Array.isArray(_data["keyConstraints"])) {
                this.keyConstraints = [] as any;
                for (let item of _data["keyConstraints"])
                    this.keyConstraints!.push(item);
            }
            this.minAnnualCapacity = _data["minAnnualCapacity"];
            this.maxAnnualCapacity = _data["maxAnnualCapacity"];
            this.hasMonthlyVariability = _data["hasMonthlyVariability"];
            this.hasProgrammedBaseline = _data["hasProgrammedBaseline"];
            this.hasAnnualCapacity = _data["hasAnnualCapacity"];
        }
    }

    static fromJS(data: any): PartDetailFilterset {
        data = typeof data === 'object' ? data : {};
        let result = new PartDetailFilterset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortDirection"] = this.sortDirection;
        data["sortBy"] = this.sortBy;
        data["pageSize"] = this.pageSize;
        data["page"] = this.page;
        if (Array.isArray(this.supplierIds)) {
            data["supplierIds"] = [];
            for (let item of this.supplierIds)
                data["supplierIds"].push(item);
        }
        if (Array.isArray(this.partNumber)) {
            data["partNumber"] = [];
            for (let item of this.partNumber)
                data["partNumber"].push(item);
        }
        if (Array.isArray(this.mitigationMeasures)) {
            data["mitigationMeasures"] = [];
            for (let item of this.mitigationMeasures)
                data["mitigationMeasures"].push(item);
        }
        if (Array.isArray(this.keyConstraints)) {
            data["keyConstraints"] = [];
            for (let item of this.keyConstraints)
                data["keyConstraints"].push(item);
        }
        data["minAnnualCapacity"] = this.minAnnualCapacity;
        data["maxAnnualCapacity"] = this.maxAnnualCapacity;
        data["hasMonthlyVariability"] = this.hasMonthlyVariability;
        data["hasProgrammedBaseline"] = this.hasProgrammedBaseline;
        data["hasAnnualCapacity"] = this.hasAnnualCapacity;
        return data;
    }

    clone(): PartDetailFilterset {
        const json = this.toJSON();
        let result = new PartDetailFilterset();
        result.init(json);
        return result;
    }
}

export interface IPartDetailFilterset {
    sortDirection?: ListSortDirection;
    sortBy?: PartDetailSortOption;
    pageSize?: number;
    page?: number;
    supplierIds?: string[] | undefined;
    partNumber?: string[] | undefined;
    mitigationMeasures?: string[] | undefined;
    keyConstraints?: string[] | undefined;
    minAnnualCapacity?: number | undefined;
    maxAnnualCapacity?: number | undefined;
    hasMonthlyVariability?: boolean | undefined;
    hasProgrammedBaseline?: boolean | undefined;
    hasAnnualCapacity?: boolean | undefined;
}
//supplyAction filter block start
export class SupplierRecoveryFilterset implements IsupplierRecoveryFilterset {
    sortDirection?: ListSortDirection;
    SortColumn?: SupplierRecoverySortOption;
    BaseSupplierId?: string | undefined;
    PageNumber?: number;
    PageSize?: number;
    partNumbers?: string[] | undefined;
    partCriticality?: string | undefined;
    minCurrentPastDueQty?: number | undefined;
    maxCurrentPastDueQty?: number | undefined;
    minEst52WeekSpend?: number | undefined;
    maxEst52WeekSpend?: number | undefined; 
    minEst52WeekVolume?: number | undefined;
    maxEst52WeekVolume?: number | undefined;
    NotShippingToMRP?: boolean | undefined;

    //PartsWithPastDueQty?: boolean | undefined;



    constructor(data?: IsupplierRecoveryFilterset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.BaseSupplierId = _data["BaseSupplierId"];
            this.PageNumber = _data["PageNumber"];
            this.PageSize = _data["PageSize"];
            this.partCriticality = _data["partCriticality"];
            this.SortColumn = _data["SortColumn"];
            this.sortDirection = _data["sortDirection"];
            if (Array.isArray(_data.partNumbers["partNumber"])) {
                this.partNumbers = [] as any;
                for (let item of _data.partNumbers["partNumber"])
                    this.partNumbers!.push(item);
            }
            this.minCurrentPastDueQty = _data["minCurrentPastDueQty"];
            this.maxCurrentPastDueQty = _data["maxCurrentPastDueQty"];
            this.minEst52WeekSpend = _data["minEst52WeekSpend"];
            this.maxEst52WeekSpend = _data["maxEst52WeekSpend"];

            this.minEst52WeekVolume = _data["minEst52WeekVolume"];
            this.maxEst52WeekVolume = _data["maxEst52WeekVolume"];
            this.NotShippingToMRP = _data["NotShippingToMRP"];
            //this.PartsWithPastDueQty = _data["PartsWithPastDueQty"];
        }

    }

    static fromJS(data: any): SupplierRecoveryFilterset {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierRecoveryFilterset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PageNumber"] = this.PageNumber;
        data["PageSize"] = this.PageSize;
        data["SortColumn"] = this.SortColumn;
        data["sortDirection"] = this.sortDirection;
        data["BaseSupplierId"] = this.BaseSupplierId;
        data["minEst52WeekVolume"] = this.minEst52WeekVolume;
        data["minCurrentPastDueQty"] = this.minCurrentPastDueQty;
        data["maxCurrentPastDueQty"] = this.maxCurrentPastDueQty;
        data["minEst52WeekSpend"] = this.minEst52WeekSpend;
        data["maxEst52WeekSpend"] = this.maxEst52WeekSpend;
        data["minEst52WeekVolume"] = this.minEst52WeekVolume;
        data["maxEst52WeekVolume"] = this.maxEst52WeekVolume;
        data["partCriticality"] = this.partCriticality;
        data["NotShippingToMRP"] = this.NotShippingToMRP;
        //data["PartsWithPastDueQty"] = this.PartsWithPastDueQty;

        if (Array.isArray(this.partNumbers)) {

            data["partNumbers"] = [];
            for (let item of this.partNumbers)
                data["partNumbers"].push(item);
        }

        return data;
    }

    clone(): SupplierRecoveryFilterset {
        const json = this.toJSON();
        let result = new SupplierRecoveryFilterset();
        result.init(json);
        return result;
    }
}
export interface IsupplierRecoveryFilterset {
    sortDirection?: ListSortDirection;
    SortColumn?: SupplierRecoverySortOption;
    BaseSupplierId?: string | undefined;
    PageNumber?: number;
    PageSize?: number;
    partNumbers?: string[] | undefined;
    partCriticality?: string | undefined;
    NotShippingToMRP?: boolean | undefined;
    PartsWithPastDueQty?: boolean | undefined;
    minEst52WeekSpend?: number | undefined;
    maxEst52WeekSpend?: number | undefined;
    minEst52WeekVolume?: number | undefined;
    maxEst52WeekVolume?: number | undefined;
    minCurrentPastDueQty?: number | undefined;
    maxCurrentPastDueQty?: number | undefined;


}
//supplyAction filter block end
export class PartDetailResponse implements IPartDetailResponse {
    data?: PartDetail[] | undefined;
    page?: number;
    totalCount?: number;

    constructor(data?: IPartDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PartDetail.fromJS(item));
            }
            this.page = _data["page"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PartDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PartDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PartDetailResponse {
        const json = this.toJSON();
        let result = new PartDetailResponse();
        result.init(json);
        return result;
    }
}

//type for supplyAction
export class supplierActionRegister implements ISupplierRecovery {
    supplierId?: string | undefined;
    baseSupplierId?: string | undefined;
    supplierName?: string | undefined;
    partNumber?: string | undefined;
    partDescription?: string | undefined;
    partCriticality?: string | undefined;
    whereUsedList?: number[] | undefined;
    est52WeekSpend?: string[] | undefined;
    est52WeekVolume?: string[] | undefined;
    currentPastDueQty?: string[] | undefined;
    production?: string | undefined;
    shippingToMRP?: string | undefined;
    lrwImpact?: string | undefined;
    currentlyNeededForLRW?: string | undefined;
    qtyRequiredForLRW?: string | undefined;
    rootCause?: string | undefined;
    recommendedCounterMeasure?: string | undefined;
    counterMeasureOwner?: string | undefined;
    estCostChange?: string | undefined;
    anticipatedMRPRecoveryDate?: string | undefined | null ;
    comments?: string | undefined;
    lastUpdatedDateTime?: Date | undefined;
    lastUpdatedUser?: string | undefined;
    sourceSystemId?: string | undefined;
    icon?: any;

    constructor(data?: ISupplierRecovery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierId = _data["supplierId"];
            this.baseSupplierId = _data["baseSupplierId"];
            this.supplierName = _data["supplierName"];
            this.partNumber = _data["partNumber"];
            this.partDescription = _data["partDescription"];
            this.partCriticality = _data["partCriticality"];
            this.whereUsedList = _data["whereUsedList"];
            this.est52WeekSpend = _data["est52WeekSpend"];
            this.est52WeekVolume = _data["est52WeekVolume"];
            this.currentPastDueQty = _data["currentPastDueQty"];
            this.production = _data["production"];
            this.shippingToMRP = _data["shippingToMRP"];
            this.lrwImpact = _data["lrwImpact"];
            this.currentlyNeededForLRW = _data["currentlyNeededForLRW"];
            this.qtyRequiredForLRW = _data["qtyRequiredForLRW"];
            this.rootCause = _data["rootCause"];
            this.recommendedCounterMeasure = _data["recommendedCounterMeasure"];
            this.counterMeasureOwner = _data["counterMeasureOwner"];
            this.estCostChange = _data["estCostChange"];
            this.anticipatedMRPRecoveryDate = _data["anticipatedMRPRecoveryDate"];
            this.comments = _data["comments"];
            this.lastUpdatedDateTime = _data["lastUpdatedDateTime"];
            this.lastUpdatedUser = _data["lastUpdatedUser"];
            this.sourceSystemId = _data["sourceSystemId"];

        }
    }

    static fromJS(data: any): supplierActionRegister {
        data = typeof data === 'object' ? data : {};
        let result = new supplierActionRegister();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId;
        data["baseSupplierId"] = this.baseSupplierId;
        data["supplierName"] = this.supplierName;
        data["partNumber"] = this.partNumber;
        data["partDescription"] = this.partDescription
        data["partCriticality"] = this.partCriticality
        data["whereUsedList"] = this.whereUsedList
        data["est52WeekSpend"] = this.est52WeekSpend
        data["est52WeekVolume"] = this.est52WeekVolume
        data["currentPastDueQty"] = this.currentPastDueQty
        data["production"] = this.production
        data["shippingToMRP"] = this.shippingToMRP
        data["lrwImpact"] = this.lrwImpact
        data["currentlyNeededForLRW"] = this.currentlyNeededForLRW
        data["qtyRequiredForLRW"] = this.qtyRequiredForLRW
        data["rootCause"] = this.rootCause
        data["recommendedCounterMeasure"] = this.recommendedCounterMeasure
        data["counterMeasureOwner"] = this.counterMeasureOwner
        data["estCostChange"] = this.estCostChange
        data["anticipatedMRPRecoveryDate"] = this.anticipatedMRPRecoveryDate
        data["comments"] = this.comments
        data["lastUpdatedDateTime"] = this.lastUpdatedDateTime ? this.lastUpdatedDateTime : <any>undefined;
        data["lastUpdatedUser"] = this.lastUpdatedUser
        data["sourceSystemId"] = this.sourceSystemId
        return data;
    }

    clone(): supplierActionRegister {
        const json = this.toJSON();
        let result = new supplierActionRegister();
        result.init(json);
        return result;
    }
}

export interface ISupplierRecovery {
    supplierId?: string | undefined;
    baseSupplierId?: string | undefined;
    supplierName?: string | undefined;
    partNumber?: string | undefined;
    partDescription?: string | undefined;
    partCriticality?: string | undefined;
    whereUsedList?: number[] | undefined;
    est52WeekSpend?: string[] | undefined;
    est52WeekVolume?: string[] | undefined;
    currentPastDueQty?: string[] | undefined;
    production?: string | undefined;
    shippingToMRP?: string | undefined;
    lRWImpact?: string | undefined;
    currentlyNeededForLRW?: string | undefined;
    qtyRequiredForLRW?: string | undefined;
    rootCause?: string | undefined;
    recommendedCounterMeasure?: string | undefined;
    counterMeasureOwner?: string | undefined;
    estCostChange?: string | undefined;
    anticipatedMRPRecoveryDate?: string | undefined  | null ;
    comments?: string | undefined;
    lastUpdatedDateTime?: Date | undefined;
    lastUpdatedUser?: string | undefined;
    sourceSystemId?: string | undefined;
}
export class SupplierRecoveryResponse implements ISupplierRecoveryResponse {
    data?: supplierActionRegister[];
    page?: number;
    totalCount?: number;

    constructor(data?: ISupplierRecoveryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(supplierActionRegister.fromJS(item));
            }
            this.data = _data["supplierActionRegister"]
            this.page = _data["page"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SupplierRecoveryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierRecoveryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SupplierRecoveryResponse {
        const json = this.toJSON();
        let result = new SupplierRecoveryResponse();
        result.init(json);
        return result;
    }
}

export interface ISupplierRecoveryResponse {
    data?: supplierActionRegister[] | undefined;
    page?: number;
    totalCount?: number;
}
//type for supplyAction end
export interface IPartDetailResponse {
    data?: PartDetail[] | undefined;
    page?: number;
    totalCount?: number;
}

export enum PartDetailSortOption {
    PartNumber = "PartNumber",
    SupplierId = "SupplierId",
    SupplierName = "SupplierName",
    AnnualCapacity = "AnnualCapacity",
    MonthlyVariability = "MonthlyVariability",
    ProgrammedBaseline = "ProgrammedBaseline",
    KeyConstraints = "KeyConstraints",
    MitigationMeasures = "MitigationMeasures",
    Undefined = "Undefined",
}

export enum SupplierRecoverySortOption {

    //icon = 'icon',
   // supplierId = 'supplierId',
    supplierName = 'supplierName',
    partNumber = 'partNumber',
   // partDescription = 'partDescription',
   // whereUsed = 'whereUsed',
   // est52WeekSpend = 'est52WeekSpend',
    //est52WeekVolume = 'est52WeekVolume',
    //currentPastDueQty = 'currentPastDueQty',
    Undefined = "",

}


export class PartNumbers implements IPartNumbers {
    partNumber?: string[] | undefined;

    constructor(data?: IPartNumbers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["partNumber"])) {
                this.partNumber = [] as any;
                for (let item of _data["partNumber"])
                    this.partNumber!.push(item);
            }
        }
    }

    static fromJS(data: any): PartNumbers {
        data = typeof data === 'object' ? data : {};
        let result = new PartNumbers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.partNumber)) {
            data["partNumber"] = [];
            for (let item of this.partNumber)
                data["partNumber"].push(item);
        }
        return data;
    }

    clone(): PartNumbers {
        const json = this.toJSON();
        let result = new PartNumbers();
        result.init(json);
        return result;
    }
}

export interface IPartNumbers {
    partNumber?: string[] | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export enum SARRequestFiltersSortColumn {
    BaseSupplierId = "BaseSupplierId",
    SupplierName = "SupplierName",
    PartNumber = "PartNumber",
    LastUpdatedDataTime = "LastUpdatedDataTime",
}



export class SupplierFilterset implements ISupplierFilterset {
    page?: number;
    pageSize?: number;
    sortBy?: SupplierSortOption;
    sortDirection?: ListSortDirection;
    supplierIds?: string[] | undefined;
    partNumber?: string[] | undefined;
    minWeeklyCapacity?: number | undefined;
    maxWeeklyCapacity?: number | undefined;
    minWeeklyDemand?: number | undefined;
    maxWeeklyDemand?: number | undefined;
    minImpliedCapacity?: number | undefined;
    maxImpliedCapacity?: number | undefined;
    minDemandUtilization?: number | undefined;
    maxDemandUtilization?: number | undefined;
    minDateUpdated?: Date | undefined;
    maxDateUpdated?: Date | undefined;
    minTenderDate?: Date | undefined;
    maxTenderDate?: Date | undefined;
    minDueDate?: Date | undefined;
    maxDueDate?: Date | undefined;
    showOnlyNullWeeklyCapacity?: boolean;
    showOnlyStaleItems?: boolean;

    constructor(data?: ISupplierFilterset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.sortBy = _data["sortBy"];
            this.sortDirection = _data["sortDirection"];
            if (Array.isArray(_data["supplierIds"])) {
                this.supplierIds = [] as any;
                for (let item of _data["supplierIds"])
                    this.supplierIds!.push(item);
            }
            if (Array.isArray(_data["partNumber"])) {
                this.partNumber = [] as any;
                for (let item of _data["partNumber"])
                    this.partNumber!.push(item);
            }
            this.minWeeklyCapacity = _data["minWeeklyCapacity"];
            this.maxWeeklyCapacity = _data["maxWeeklyCapacity"];
            this.minWeeklyDemand = _data["minWeeklyDemand"];
            this.maxWeeklyDemand = _data["maxWeeklyDemand"];
            this.minImpliedCapacity = _data["minImpliedCapacity"];
            this.maxImpliedCapacity = _data["maxImpliedCapacity"];
            this.minDemandUtilization = _data["minDemandUtilization"];
            this.maxDemandUtilization = _data["maxDemandUtilization"];
            this.minDateUpdated = _data["minDateUpdated"] ? new Date(_data["minDateUpdated"].toString()) : <any>undefined;
            this.maxDateUpdated = _data["maxDateUpdated"] ? new Date(_data["maxDateUpdated"].toString()) : <any>undefined;
            this.minTenderDate = _data["minTenderDate"] ? new Date(_data["minTenderDate"].toString()) : <any>undefined;
            this.maxTenderDate = _data["maxTenderDate"] ? new Date(_data["maxTenderDate"].toString()) : <any>undefined;
            this.minDueDate = _data["minDueDate"] ? new Date(_data["minDueDate"].toString()) : <any>undefined;
            this.maxDueDate = _data["maxDueDate"] ? new Date(_data["maxDueDate"].toString()) : <any>undefined;
            this.showOnlyNullWeeklyCapacity = _data["showOnlyNullWeeklyCapacity"];
            this.showOnlyStaleItems = _data["showOnlyStaleItems"];
        }
    }

    static fromJS(data: any): SupplierFilterset {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierFilterset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["sortBy"] = this.sortBy;
        data["sortDirection"] = this.sortDirection;
        if (Array.isArray(this.supplierIds)) {
            data["supplierIds"] = [];
            for (let item of this.supplierIds)
                data["supplierIds"].push(item);
        }
        if (Array.isArray(this.partNumber)) {
            data["partNumber"] = [];
            for (let item of this.partNumber)
                data["partNumber"].push(item);
        }
        data["minWeeklyCapacity"] = this.minWeeklyCapacity;
        data["maxWeeklyCapacity"] = this.maxWeeklyCapacity;
        data["minWeeklyDemand"] = this.minWeeklyDemand;
        data["maxWeeklyDemand"] = this.maxWeeklyDemand;
        data["minImpliedCapacity"] = this.minImpliedCapacity;
        data["maxImpliedCapacity"] = this.maxImpliedCapacity;
        data["minDemandUtilization"] = this.minDemandUtilization;
        data["maxDemandUtilization"] = this.maxDemandUtilization;
        data["minDateUpdated"] = this.minDateUpdated ? this.minDateUpdated.toISOString() : <any>undefined;
        data["maxDateUpdated"] = this.maxDateUpdated ? this.maxDateUpdated.toISOString() : <any>undefined;
        data["minTenderDate"] = this.minTenderDate ? this.minTenderDate.toISOString() : <any>undefined;
        data["maxTenderDate"] = this.maxTenderDate ? this.maxTenderDate.toISOString() : <any>undefined;
        data["minDueDate"] = this.minDueDate ? this.minDueDate.toISOString() : <any>undefined;
        data["maxDueDate"] = this.maxDueDate ? this.maxDueDate.toISOString() : <any>undefined;
        data["showOnlyNullWeeklyCapacity"] = this.showOnlyNullWeeklyCapacity;
        data["showOnlyStaleItems"] = this.showOnlyStaleItems;
        return data;
    }

    clone(): SupplierFilterset {
        const json = this.toJSON();
        let result = new SupplierFilterset();
        result.init(json);
        return result;
    }
}

export interface ISupplierFilterset {
    page?: number;
    pageSize?: number;
    sortBy?: SupplierSortOption;
    sortDirection?: ListSortDirection;
    supplierIds?: string[] | undefined;
    partNumber?: string[] | undefined;
    minWeeklyCapacity?: number | undefined;
    maxWeeklyCapacity?: number | undefined;
    minWeeklyDemand?: number | undefined;
    maxWeeklyDemand?: number | undefined;
    minImpliedCapacity?: number | undefined;
    maxImpliedCapacity?: number | undefined;
    minDemandUtilization?: number | undefined;
    maxDemandUtilization?: number | undefined;
    minDateUpdated?: Date | undefined;
    maxDateUpdated?: Date | undefined;
    minTenderDate?: Date | undefined;
    maxTenderDate?: Date | undefined;
    minDueDate?: Date | undefined;
    maxDueDate?: Date | undefined;
    showOnlyNullWeeklyCapacity?: boolean;
    showOnlyStaleItems?: boolean;
}

export class SupplierIdName implements ISupplierIdName {
    baseSupplierId?: string | undefined;
    name?: string | undefined;

    constructor(data?: ISupplierIdName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSupplierId = _data["baseSupplierId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SupplierIdName {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierIdName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSupplierId"] = this.baseSupplierId;
        data["name"] = this.name;
        return data;
    }

    clone(): SupplierIdName {
        const json = this.toJSON();
        let result = new SupplierIdName();
        result.init(json);
        return result;
    }
}

export interface ISupplierIdName {
    baseSupplierId?: string | undefined;
    name?: string | undefined;
}

export class SupplierIds implements ISupplierIds {
    supplierId?: string[] | undefined;

    constructor(data?: ISupplierIds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["supplierId"])) {
                this.supplierId = [] as any;
                for (let item of _data["supplierId"])
                    this.supplierId!.push(item);
            }
        }
    }

    static fromJS(data: any): SupplierIds {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierIds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.supplierId)) {
            data["supplierId"] = [];
            for (let item of this.supplierId)
                data["supplierId"].push(item);
        }
        return data;
    }

    clone(): SupplierIds {
        const json = this.toJSON();
        let result = new SupplierIds();
        result.init(json);
        return result;
    }
}

export interface ISupplierIds {
    supplierId?: string[] | undefined;
}

export class SupplierInfo implements ISupplierInfo {
    supplierId?: string | undefined;
    supplierName?: string | undefined;
    partNumber?: string | undefined;
    partDescription?: string | undefined;
    tenderDate?: Date | undefined;
    dueDate?: Date | undefined;
    weeklyDemand?: number | undefined;
    impliedCapacity?: number | undefined;
    weeklyCapacity?: number | undefined;
    demandUtilization?: number | undefined;
    dateUpdated?: Date | undefined;
    lastUpdatedBy?: string | undefined;
    demandId?: string | undefined;
    notes?: string | undefined;
    programmedBaseline?: boolean;

    constructor(data?: ISupplierInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.partNumber = _data["partNumber"];
            this.partDescription = _data["partDescription"];
            this.tenderDate = _data["tenderDate"] ? new Date(_data["tenderDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.weeklyDemand = _data["weeklyDemand"];
            this.impliedCapacity = _data["impliedCapacity"];
            this.weeklyCapacity = _data["weeklyCapacity"];
            this.demandUtilization = _data["demandUtilization"];
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.demandId = _data["demandId"];
            this.notes = _data["notes"];
            this.programmedBaseline = _data["programmedBaseline"];
        }
    }

    static fromJS(data: any): SupplierInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["partNumber"] = this.partNumber;
        data["partDescription"] = this.partDescription;
        data["tenderDate"] = this.tenderDate ? this.tenderDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["weeklyDemand"] = this.weeklyDemand;
        data["impliedCapacity"] = this.impliedCapacity;
        data["weeklyCapacity"] = this.weeklyCapacity;
        data["demandUtilization"] = this.demandUtilization;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["demandId"] = this.demandId;
        data["notes"] = this.notes;
        data["programmedBaseline"] = this.programmedBaseline;
        return data;
    }

    clone(): SupplierInfo {
        const json = this.toJSON();
        let result = new SupplierInfo();
        result.init(json);
        return result;
    }
}

export interface ISupplierInfo {
    supplierId?: string | undefined;
    supplierName?: string | undefined;
    partNumber?: string | undefined;
    partDescription?: string | undefined;
    tenderDate?: Date | undefined;
    dueDate?: Date | undefined;
    weeklyDemand?: number | undefined;
    impliedCapacity?: number | undefined;
    weeklyCapacity?: number | undefined;
    demandUtilization?: number | undefined;
    dateUpdated?: Date | undefined;
    lastUpdatedBy?: string | undefined;
    demandId?: string | undefined;
    notes?: string | undefined;
    programmedBaseline?: boolean;
}

export class SupplierInfoResponse implements ISupplierInfoResponse {
    data?: SupplierInfo[] | undefined;
    page?: number;
    totalCount?: number;

    constructor(data?: ISupplierInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SupplierInfo.fromJS(item));
            }
            this.page = _data["page"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SupplierInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SupplierInfoResponse {
        const json = this.toJSON();
        let result = new SupplierInfoResponse();
        result.init(json);
        return result;
    }
}

export interface ISupplierInfoResponse {
    data?: SupplierInfo[] | undefined;
    page?: number;
    totalCount?: number;
}

export enum SupplierSortOption {
    Demand = "Demand",
    DemandUtilization = "DemandUtilization",
    DueDate = "DueDate",
    ImpliedCapacity = "ImpliedCapacity",
    LastUpdatedDate = "LastUpdatedDate",
    PartNumber = "PartNumber",
    SupplierId = "SupplierId",
    TenderDate = "TenderDate",
    Undefined = "Undefined",
    WeeklyCapacity = "WeeklyCapacity",
    SupplierName = "SupplierName",
}

export enum TaskType {
    ApproachingThreshold = "ApproachingThreshold",
    OverThreshold = "OverThreshold",
}

export class UserInfo implements IUserInfo {
    roles?: string[] | undefined;
    supplierIds?: string[] | undefined;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["supplierIds"])) {
                this.supplierIds = [] as any;
                for (let item of _data["supplierIds"])
                    this.supplierIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.supplierIds)) {
            data["supplierIds"] = [];
            for (let item of this.supplierIds)
                data["supplierIds"].push(item);
        }
        return data;
    }

    clone(): UserInfo {
        const json = this.toJSON();
        let result = new UserInfo();
        result.init(json);
        return result;
    }
}

export interface IUserInfo {
    roles?: string[] | undefined;
    supplierIds?: string[] | undefined;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    errors?: { [key: string]: string[]; } | undefined;
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = this.errors[key];
            }
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }

    clone(): ValidationProblemDetails {
        const json = this.toJSON();
        let result = new ValidationProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IValidationProblemDetails {
    errors?: { [key: string]: string[]; } | undefined;
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export class WhereUsedList implements IWhereUsedList {
    whereUsed?: string[] | undefined;

    constructor(data?: IWhereUsedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["whereUsed"])) {
                this.whereUsed = [] as any;
                for (let item of _data["whereUsed"])
                    this.whereUsed!.push(item);
            }
        }
    }

    static fromJS(data: any): WhereUsedList {
        data = typeof data === 'object' ? data : {};
        let result = new WhereUsedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.whereUsed)) {
            data["whereUsed"] = [];
            for (let item of this.whereUsed)
                data["whereUsed"].push(item);
        }
        return data;
    }

    clone(): WhereUsedList {
        const json = this.toJSON();
        let result = new WhereUsedList();
        result.init(json);
        return result;
    }
}

export interface IWhereUsedList {
    whereUsed?: string[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}